/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type FishLeaderboardResult_getFishLeaderboard$ref: FragmentReference;
declare export opaque type FishLeaderboardResult_getFishLeaderboard$fragmentType: FishLeaderboardResult_getFishLeaderboard$ref;
export type FishLeaderboardResult_getFishLeaderboard = {|
  +getFishLeaderboard: ?{|
    +code: ?number,
    +message: ?string,
    +data: ?{|
      +points_per_team: ?$ReadOnlyArray<?{|
        +group_id: ?number,
        +points: ?number,
        +position: ?string,
      |}>,
      +all_answers: ?$ReadOnlyArray<?{|
        +group_id: ?number,
        +points: ?number,
        +guest: ?{|
          +guest_name: ?string
        |},
      |}>,
    |},
  |},
  +$refType: FishLeaderboardResult_getFishLeaderboard$ref,
|};
export type FishLeaderboardResult_getFishLeaderboard$data = FishLeaderboardResult_getFishLeaderboard;
export type FishLeaderboardResult_getFishLeaderboard$key = {
  +$data?: FishLeaderboardResult_getFishLeaderboard$data,
  +$fragmentRefs: FishLeaderboardResult_getFishLeaderboard$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "group_id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "points",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "FishLeaderboardResult_getFishLeaderboard",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "event_token",
      "type": "String!",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "getFishLeaderboard",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "event_token",
          "variableName": "event_token"
        }
      ],
      "concreteType": "fishLeaderboardType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "message",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "data",
          "storageKey": null,
          "args": null,
          "concreteType": "fishLeaderboardDataType",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "points_per_team",
              "storageKey": null,
              "args": null,
              "concreteType": "pointsPerTeamType",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "position",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "all_answers",
              "storageKey": null,
              "args": null,
              "concreteType": "allAnswersType",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "guest",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "fishGuestType",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "guest_name",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '8ea6068a43febea8da504aeeeaecedc3';
module.exports = node;
